export default "__VITE_ASSET__CSzOv0Z___"